const initialState = {
    currentLanguage: '',
    currentCurrency: '',
    currentDateFormat: '',
    currentThousandSeparater: '',
    currentDecimalSeparater: '',
    systemCountryCode: '',
    systemDateFormat: '',
    thousandSeparater: '',
    decimalSeparater: '',
    systemPhoneCode: '',
    minAccountNoLength: 0,
    maxAccountNoLength: 0,
    error: null,
}

export default (state = initialState, action: any) => {
    let newState = state;

    switch (action.type) {

        case 'CHANGE_LANGUAGE':
            newState = {
                ...state,
                currentLanguage: action.language,
                currentCurrency: action.currency,
                currentDateFormat: action.dateFormat,
                currentThousandSeparater: action.thousandSeparater,
                currentDecimalSeparater: action.decimalSeparater,
                error: null
            }
            break;
        case 'CHANGE_REGIONAL_SETTINGS':
            const { countryCode, systemDateFormat, phoneCountryCode, thousandSeparator, decimalSepearator, minAccountNoLength, maxAccountNoLength } = action.payload ?? {};
            
            newState = {
                ...state,
                systemCountryCode: countryCode,
                systemDateFormat: systemDateFormat,
                thousandSeparater: thousandSeparator,
                decimalSeparater: decimalSepearator,
                systemPhoneCode: phoneCountryCode,
                minAccountNoLength: minAccountNoLength, 
                maxAccountNoLength: maxAccountNoLength,
                error: null
            }
            break;

        default:
            break;
    }
    return newState;
};